import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';
import { File } from './file';

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    cover: 'cover',
  },
  relation: {
    cover: File
  }
})
export class TournamentDivision extends BaseModel {
  id: number;
  name: string;
  cover: File;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
